// import React, { useState } from "react";
// import { useTranslation } from "react-i18next";

// interface FAQItem {
//   question: string;
//   answer: string;
// }

// const FaqSection: React.FC = () => {
//   const [activeTab, setActiveTab] = useState<string>("Product Information");
//   const [openQuestion, setOpenQuestion] = useState<number | null>(null);
//   const { t } = useTranslation("global");

//   const tabs: string[] = [
//     "contact.product.title",
//     "Warranty and Services",
//     "Ordering and Support",
//   ];

//   const faqData: { [key: string]: FAQItem[] } = {
//     "Product Information": [
//       {
//         question: "What materials are Elyumax products made from?",
//         answer:
//           "Our products are primarily made from high-quality aluminum, known for its durability and resistance to corrosion.",
//       },
//       {
//         question: "Do you offer customization options for windows and doors?",
//         answer:
//           "Yes, we offer a variety of customization options to suit your needs.",
//       },
//       {
//         question: "Are there color options available for Elyumax products?",
//         answer:
//           "Absolutely! Elyumax offers a wide range of colors to match your design preferences.",
//       },
//       {
//         question: "Can Elyumax products be used for commercial projects?",
//         answer:
//           "Yes, our products are designed for both residential and commercial projects.",
//       },
//     ],
//     "Warranty and Services": [
//       {
//         question: "What is the warranty period for your products?",
//         answer: "Our products come with a standard 10-year warranty period.",
//       },
//       {
//         question:
//           "Do Elyumax aluminum profiles comply with industry standards?",
//         answer:
//           "Yes, all our aluminum profiles comply with international industry standards for quality and safety.",
//       },
//       {
//         question: "How does Elyumax support sustainable building practices?",
//         answer:
//           "We ensure that our materials are environmentally friendly and support sustainable building practices.",
//       },
//       {
//         question: "Are Elyumax products energy efficient?",
//         answer:
//           "Yes, Elyumax products are designed to provide excellent energy efficiency and thermal insulation.",
//       },
//     ],
//     "Ordering and Support": [
//       {
//         question: "Can I order Elyumax products online?",
//         answer:
//           "Yes, Elyumax products can be ordered online through our official website or by contacting our sales team directly for assistance.",
//       },
//       {
//         question: "What is the lead time for Elyumax products?",
//         answer:
//           "The standard lead time for Elyumax products is typically between 4 to 6 weeks, depending on the order size and customization requirements. For more precise timelines, please contact our sales team.",
//       },
//       {
//         question: "How can I get a quote for a large project?",
//         answer:
//           "To get a quote for a large project, please reach out to our sales team by filling out the contact form on our website or emailing us directly. Provide details about your project, including specifications, quantities, and timelines, so we can provide you with a customized quote.",
//       },
//       {
//         question: "How do I maintain my aluminum windows and doors?",
//         answer:
//           "To maintain your aluminum windows and doors, clean the frames regularly with mild soap and water using a soft cloth. Avoid abrasive cleaners or materials that could scratch the surface. Lubricate moving parts such as hinges and locks annually for smooth operation, and inspect seals for wear to ensure optimal performance.",
//       },
//     ],
//   };

//   return (
//     <div className="w-full max-w-5xl mx-auto px-4 py-6 md:py-10">
//       {/* Heading */}
//       <div className="flex justify-center items-center pb-14 md:pt-3">
//         <span className="title font-bold text-4xl">FAQs</span>
//       </div>
//       {/* Tabs */}
//       <div className="flex md:flex-row flex-col md:space-x-8 space-y-2 md:space-y-0 justify-center items-center">
//         {tabs.map((tab) => (
//           <button
//             key={tab}
//             className={`text-lg font-normal font ${
//               activeTab === tab
//                 ? "text-red-500 border-2 border-red-400 pl-2 pr-2 space-y-2"
//                 : "text-gray-500 hover:text-gray-700"
//             }`}
//             onClick={() => setActiveTab(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* FAQ Questions */}
//       <div className="mt-6 space-y-4 font font-normal">
//         {faqData[activeTab]?.map((item, index) => (
//           <div key={index} className="bg-gray-50 rounded-md">
//             <button
//               className="w-full text-left p-4 flex items-center justify-between"
//               onClick={() =>
//                 setOpenQuestion(openQuestion === index ? null : index)
//               }
//             >
//               <span className="text-lg text-gray-800">{item.question}</span>
//               <span
//                 className={`w-6 md:w-4 h-4 md:h-4 border ${
//                   openQuestion === index
//                     ? "bg-red-500 border-red-500"
//                     : "border-gray-800"
//                 }`}
//               ></span>
//             </button>
//             {openQuestion === index && (
//               <div className="pl-4 pb-4 text-base bg-gray-50 text-gray-700">
//                 {item.answer}
//               </div>
//             )}
//           </div>
//         ))}
//       </div>

//       {/* Still Have Questions Section */}
//       <div className="flex flex-col justify-center items-center text-center mt-12">
//         <div className="border-t border-black w-16 mx-auto mb-12"></div>
//         <h2 className="text-2xl title font-medium mb-2">
//           Still have questions?
//         </h2>
//         <p className="text-gray-800 max-w-lg mx-auto mb-6 font font-normal text-lg">
//           We’re here for you! Reach out to us, and our team will be happy to
//           give you the personalized support you deserve.
//         </p>
//         {/* <button className="color text-white px-6 py-2 hover:bg-red-500 transition duration-300">
//           Get in touch
//         </button> */}
//         <button
//           className="color text-white px-6 py-2 hover:bg-red-500 transition duration-300"
//           onClick={() => {
//             document.getElementById("contact-section")?.scrollIntoView({
//               behavior: "smooth",
//             });
//           }}
//         >
//           Get in touch
//         </button>
//       </div>
//     </div>
//   );
// };

// export default FaqSection;

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import '../../components/header/shiny.button.css'

interface FAQItem {
  question: string;
  answer: string;
}

const FaqSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>("contact.product.title");
  const [openQuestion, setOpenQuestion] = useState<number | null>(null);
  const { t } = useTranslation("global");

  const tabs: string[] = [
    "contact.product.title",
    "contact.warranty.title",
    "contact.order.title",
  ];

  const faqData: { [key: string]: FAQItem[] } = {
    "contact.product.title": [
      {
        question: t("contact.product.no_1.question"),
        answer: t("contact.product.no_1.answer"),
      },
      {
        question: t("contact.product.no_2.question"),
        answer: t("contact.product.no_2.answer"),
      },
      {
        question: t("contact.product.no_3.question"),
        answer: t("contact.product.no_3.answer"),
      },
      {
        question: t("contact.product.no_4.question"),
        answer: t("contact.product.no_4.answer"),
      },
    ],
    "contact.warranty.title": [
      {
        question: t("contact.warranty.no_1.question"),
        answer: t("contact.warranty.no_1.answer"),
      },
      {
        question: t("contact.warranty.no_2.question"),
        answer: t("contact.warranty.no_2.answer"),
      },
      {
        question: t("contact.warranty.no_3.question"),
        answer: t("contact.warranty.no_3.answer"),
      },
      {
        question: t("contact.warranty.no_4.question"),
        answer: t("contact.warranty.no_4.answer"),
      },
    ],
    "contact.order.title": [
      {
        question: t("contact.order.no_1.question"),
        answer: t("contact.order.no_1.answer"),
      },
      {
        question: t("contact.order.no_2.question"),
        answer: t("contact.order.no_2.answer"),
      },
      {
        question: t("contact.order.no_3.question"),
        answer: t("contact.order.no_3.answer"),
      },
      {
        question: t("contact.order.no_4.question"),
        answer: t("contact.order.no_4.answer"),
      },
    ],
  };

  return (
    <div className="w-full max-w-5xl mx-auto px-4 py-6 md:py-10" >
      {/* Heading */}
      <div className="flex justify-center items-center pb-6 md:pt-3" >
        <span className="title font-bold text-4xl">FAQs</span>
      </div>
      {/* Tabs */}
      <div className="flex md:flex-row flex-col md:space-x-8 space-y-2 md:space-y-0 justify-center items-center" >
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`text-lg font-normal font ${
              activeTab === tab
                ? "text-red-500 border-2 border-red-400 pl-2 pr-2 space-y-2"
                : "text-gray-500 hover:text-gray-700"
            }`}
            style={{ fontFamily: "'Nunito Sans', sans-serif",fontWeight:400, }}
            onClick={() => setActiveTab(tab)}
          >
            {t(tab)}
          </button>
        ))}
      </div>

      {/* FAQ Questions */}
      <div className="mt-6 space-y-4 font font-normal" style={{ fontFamily: "'Nunito Sans', sans-serif",fontWeight:400, }}>
        {faqData[activeTab]?.map((item, index) => (
          <div key={index} className="bg-gray-50 rounded-md">
            <button
              className="w-full text-left p-4 flex items-center justify-between"
              onClick={() =>
                setOpenQuestion(openQuestion === index ? null : index)
              }
            >
              <span className="text-lg text-gray-800">{item.question}</span>
              <span
                className={`w-6 md:w-4 h-4 md:h-4 border ${
                  openQuestion === index
                    ? "bg-red-500 border-red-500"
                    : "border-gray-800"
                }`}
              ></span>
            </button>
            {openQuestion === index && (
              <div className="pl-4 pb-4 text-base bg-gray-50 text-gray-700">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Still Have Questions Section */}
      <div className="flex flex-col justify-center items-center text-center mt-12">
        <div className="border-t border-black w-16 mx-auto mb-12"></div>
        <h2 className="text-2xl title font-medium mb-2">
          {t("contact.still")}
        </h2>
        <p className="text-gray-800 max-w-lg mx-auto mb-6 font font-normal text-lg" style={{ fontFamily: "'Nunito Sans', sans-serif",fontWeight:400, }}>
          {t("contact.des")}
        </p>
        <button
          id="shiny-red-button"
          className="color text-white px-6 py-3  font-medium text-base"
          onClick={() => {
            const headerHeight = document.querySelector("header")?.offsetHeight || 0; // Get header height
            const targetPosition = document.getElementById("contact-section")?.offsetTop || 0;
          
            window.scrollTo({
              top: targetPosition - headerHeight, // Subtract the header height
              behavior: "smooth", // Smooth scrolling effect
            });
          }}
        >
          {t("footer.get-in-touch.title")}
        </button>
      </div>
    </div>
  );
};

export default FaqSection;
